var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.69843 8.93994C1.51709 8.69127 1.42643 8.56661 1.36376 8.32661C1.32145 8.1129 1.32145 7.89298 1.36376 7.67927C1.42643 7.43861 1.51709 7.31394 1.69843 7.06594C2.69109 5.7026 4.86709 3.33594 7.99843 3.33594C11.1298 3.33594 13.3058 5.7026 14.2984 7.06527C14.4798 7.31394 14.5704 7.43861 14.6331 7.67861C14.6754 7.89231 14.6754 8.11223 14.6331 8.32594C14.5704 8.56661 14.4798 8.69127 14.2984 8.93927C13.3058 10.3026 11.1298 12.6693 7.99843 12.6693C4.86709 12.6693 2.69109 10.3026 1.69843 8.93994Z",
    stroke: "#FCFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9974 9.33854C8.35102 9.33854 8.69016 9.19807 8.9402 8.94802C9.19025 8.69797 9.33073 8.35883 9.33073 8.00521C9.33073 7.65159 9.19025 7.31245 8.9402 7.0624C8.69016 6.81235 8.35102 6.67188 7.9974 6.67188C7.64377 6.67188 7.30464 6.81235 7.05459 7.0624C6.80454 7.31245 6.66406 7.65159 6.66406 8.00521C6.66406 8.35883 6.80454 8.69797 7.05459 8.94802C7.30464 9.19807 7.64377 9.33854 7.9974 9.33854Z",
    stroke: "#FCFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.984ff405dad201476eeb85bf2515d97a.svg";
export { ForwardRef as ReactComponent };